<template>
    <v-app-bar
        app
        flat
        color="#F2F6FF">
        <v-app-bar-nav-icon
          @click="mostrarOcultarMenu">
        </v-app-bar-nav-icon>
        <v-toolbar-title>
          <span class="text-uppercase">
            <template
              v-if="!$vuetify.breakpoint.mobile">
              DAESA INGENIERÍA
            </template>
            <template
              v-else>
              DAESA INGENIERÍA
            </template>
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <menu-usuario></menu-usuario>
        <!-- <v-btn
          depressed
          rounded
          text
          :to="{ name: 'logout' }">
          <v-icon
            left>
            mdi-logout
          </v-icon>
          Salir
        </v-btn> -->
    </v-app-bar>
</template>

<script>
import MenuUsuario from './MenuUsuario.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainAppBar',
  components: {
    MenuUsuario,
  },
  data() {
    return {};
  },
  methods: {
    mostrarOcultarMenu() {
      eventBus.$emit('mostrar-ocultar-menu');
    },
  },
};
</script>

<style lang="scss">

</style>
